const c = {
  name: "Hands11101",
  dimensions: { width: 35, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 40" style="enable-background:new 0 0 35 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27,12.5c-0.6-0.3-1.3-0.5-2-0.5s-1.4,0.2-2,0.5V4c0-2.2-1.8-4-4-4c-1.7,0-3.2,1.1-3.8,2.7
			C14.6,2.2,13.8,2,13,2c-2.2,0-4,1.8-4,4v15.5l-2-2.1c-1.4-1.7-3.9-1.9-5.6-0.5c-1.7,1.4-1.9,3.9-0.5,5.6l1.9,2.3l6.7,7.5
			C12.7,38,17.3,40,22,40c7.2,0,13-5.8,13-13V10.4C35,8.1,33.3,6,31,6s-4,2.1-4,4.4V12.5z M17,4c0-1.1,0.9-2,2-2s2,0.9,2,2v17h-4V4z
			 M13,21v2h8c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4h2v-2h-2V10.4C29,9,30,8,31,8c1,0,2,1,2,2.4V27c0,6.1-4.9,11-11,11
			c-4.2,0-8.1-1.8-10.9-4.9l-6.7-7.5l-1.9-2.3c-0.7-0.8-0.6-2.1,0.2-2.8c0.8-0.7,2.1-0.6,2.8,0.2l0,0l5.4,5.7V6c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2v15H13z M27,16v7c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2v-7c0-1.1,0.9-2,2-2C26.1,14,27,14.9,27,16z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands11101
};
